var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["badges/heart-with-circle.j2"] = require( "badges/heart-with-circle.j2" );
dependencies["badges/heart.j2"] = require( "badges/heart.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-favorited.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-favorited\">\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"favoritable")) {
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")) {
output += "\n\n            <span class=\"c-product-heart c-product-heart__tile js-favorite-toggle ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"favorited")) {
output += "is-favorited";
;
}
output += "\" data-qa-product-heart-icon ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"favorited")) {
output += "data-qa-product-is-hearted";
;
}
output += ">\n\n                ";
env.getTemplate("badges/heart-with-circle.j2", false, "product/templates/product-favorited.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n            </span>\n\n        ";
})});
}
else {
output += "\n\n            <span class=\"c-product-heart-container js-favorite-toggle ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"favorited")) {
output += "is-favorited";
;
}
output += "\" data-qa-product-heart-container ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"favorited")) {
output += "data-qa-product-is-hearted";
;
}
output += ">\n\n                 <span class=\"c-product-heart-container__count\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"social")),"likes"), env.opts.autoescape);
output += "</span>\n\n                 <span class=\"c-product-heart-container__icon\" data-qa-product-heart-icon>";
env.getTemplate("badges/heart.j2", false, "product/templates/product-favorited.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "</span>\n            </span>\n\n        ";
})});
}
output += "\n\n    ";
;
}
output += "\n\n</div>\n\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-favorited.j2"] , dependencies)